import React from 'react';
import moment from 'moment';
import 'moment/min/locales';
import axios from '../../config/axiosInstance';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import { fetchTaskSchedules, updateTaskScheduleName } from '../../store/actions/taskSchedule';
import { Typography, ExpansionPanelSummary, ExpansionPanelDetails, ExpansionPanel, Paper, DialogContentText, TextField, withStyles } from '@material-ui/core';
import { ExpandMore, CompareArrows, Person, DateRange, Schedule, TransferWithinAStation, Description, AddAlarm, Check, Star, Close } from '@material-ui/icons';
import { List, ListItem, ListItemText, ListItemAvatar, Avatar, Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@material-ui/core';
import DataTable from '../../components/DataTable/DataTable';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '../../components/Input/Input';
import Divider from "@material-ui/core/Divider";


const styles = theme => ({
    timeInputContainer: {
        flexDirection: 'column',
        marginTop: '20px',
    },
    timeSpan: {
        color: '#0000008a',
    },
    basis50: {
        flexBasis: '50%',
    },
    dateTimeInput: {
        width: '48%',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%',
    },
    dense: {
        marginTop: 19,
        marginLeft: 0,
    }
});

export class TaskScheduleDuplicatePoint extends React.Component {
    state = {
        openModalTipo: false,
        openAdd: false,
        openModalAprovar: false,
        openReprove: false,
        openModalAproveAll: false,
        type: '',
        newTime: null,
        newDate: null,
        descricaoAproveAll: '',
        observationDescription: '',
        currentStatus: {
            timeclockId: '',
            employeeId: '',
            employee: {
                name: '',
            },
            timeclock: {
                type: '',
                dtRegister: '',
                addressLocation: '',
            },
            rulerdetailsjson: {
                previousTimeclockData: {
                    type: '',
                    dtRegister: ''
                }
            }

        },
    };

    openModal = (status, item) => {
        this.setState({ currentStatus: this.props.taskschedules.find(tasks => tasks.id === item) });
        if (status == 'openModalAprovar') { this.setState({ openModalAprovar: true }); }
        if (status == 'openReprove') { this.setState({ openReprove: true }); }
        if (status == 'openModalTipo') { this.setState({ openModalTipo: true }); }
        if (status == 'openAdd') { this.setState({ openAdd: true }); }
    };

    closeModal = (status) => {
        if (status == 'openModalAprovar') { this.setState({ openModalAprovar: false, observationDescription: '' }); }
        if (status == 'openReprove') { this.setState({ openReprove: false, observationDescription: '' }); }
        if (status == 'openModalTipo') { this.setState({ openModalTipo: false, observationDescription: '', type: '' }); }
        if (status == 'openAdd') { this.setState({ openAdd: false, observationDescription: '', type: '', newTime: null }); }
        else if (status == 'modalAproveAll') { this.setState({ openModalAproveAll: false, descricaoAproveAll: '' }); }
    };

    handleChange = (event, type) => {
        let newatime = { ...this.state.time };
        let newDate = { ...this.state.date };
        switch (type) {
            case 'observation':
                this.setState({ observationDescription: event.target.value });
                break;
            case 'time':
                newatime = event;
                this.setState({ newTime: newatime });
                break;
            case 'date':
                newDate = event
                this.setState({ newDate: newDate });
                break;
            case 'type':
                this.setState({ type: event.target.value });
                break;
            case 'descricaoAproveAll':
                this.setState({ descricaoAproveAll: event.target.value });
                break;
        }
    };

    approveAll = () => {
        axios.put('/event/', {
            id: this.props.taskschedules.filter(f => f.typeEventId === 3).map(i => i.id),
            statusaction: "APROVADO",
            description: "Pontos duplicados aprovados.",
        })
        this.props.onFetchTaskSchedules();
        this.props.onFetchTaskSchedules();
        this.closeModal("modalAproveAll");
    };

    finishActions = (status) => {
        axios
            .post('timeSheet/actions', {
                employeeId: this.state.currentStatus.employeeId,
                actions: [{
                    action: 'ADD',
                    type: this.state.type,
                    dtRegister: `${moment(this.state.currentStatus.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('YYYY-MM-DD')}  ${moment(this.state.newTime, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm')}`,
                    justification: this.state.observationDescription,
                }],
            })
        if (status == 'REJEITADO') { this.handleAprova('REJEITADO') }
    };

    rejectPoint = (status) => {
        axios
            .post('timeSheet/actions', {
                employeeId: this.state.currentStatus.employeeId,
                actions: [{
                    action: "REM",
                    category: null,
                    categoryRemake: "",
                    isRemake: false,
                    id: this.state.currentStatus.timeclockId, //id do ponto == timeclockId
                    dtRegister: this.state.currentStatus.timeclock.dtRegister,
                    justification: this.state.observationDescription,
                    name: "inativar",
                }],
            })
        if (status == 'REJEITADO') { this.handleAprova('REJEITADO') }
    };

    updateType = (status) => {
        axios
            .put('timeclocks/updateType', {
                timeclockId: this.state.currentStatus.timeclockId,
                type: this.state.type,
            })
        if (status == 'REJEITADO') { this.handleAprova('REJEITADO') }
    };

    handleAprova = (status) => {
        if (status == 'APROVAR') {
            this.props.onUpdateTaskScheduleName(this.state.currentStatus.id, 'APROVADO', this.state.observationDescription);
            this.props.onFetchTaskSchedules();
            this.props.onFetchTaskSchedules();
            this.closeModal('openModalAprovar');
        }
        else if (status == 'REJEITADO') {
            this.props.onUpdateTaskScheduleName(this.state.currentStatus.id, 'REJEITADO', this.state.observationDescription);
            this.props.onFetchTaskSchedules();
            this.props.onFetchTaskSchedules();
            this.closeModal('openModalTipo');
            this.closeModal('openAdd');
            this.closeModal('openReprove');
        }
    };

    handleModalAproveAll = () => {
        this.setState({ openModalAproveAll: true });
    }

    render() {
        const { taskschedules, loading, classes, isPremium } = this.props;

        const columns = [
            { name: 'dtRegister', label: 'Data' },
            { name: 'timeRegister', label: 'Hora' },
            { name: 'type', label: 'Tipo' },
            { name: 'name', label: 'Nome' },
            { name: 'addressLocation', label: 'Endereço' },
        ];

        const actions = [
            {
                name: 'Aprovar',
                icon: Check,
                onClick: item => this.openModal('openModalAprovar', item.id),
            },
            {
                name: 'Alterar Tipo',
                icon: CompareArrows,
                onClick: item => this.openModal('openModalTipo', item.id),
            },
            {
                name: 'Adicionar Ponto',
                icon: AddAlarm,
                onClick: item => this.openModal('openAdd', item.id),
            },
            {
                name: 'Remover Ponto',
                icon: Close,
                onClick: item => this.openModal('openReprove', item.id),
            },
        ];

        return (
            <Paper elevation={2} style={{ margin: 10 }}>
                {/* {
                    !taskschedules.filter(i => i.typeEventId === 3).length ?
                        (
                            <Typography align="center" style={{ padding: 10 }}> Não há pontos duplicado no momento.</Typography>
                        ) :
                        // <ExpansionPanel style={{ marginTop: 5 }}>
                        //     <ExpansionPanelSummary expandIcon={<ExpandMore />} IconButtonProps={{ style: { position: 'absolute', right: '14px' } }}>
                        //         <Typography item md={5}>Existem {taskschedules.filter(i => i.typeEventId === 3).length} Pontos  duplicado.</Typography>
                        //     </ExpansionPanelSummary>

                        //     <ExpansionPanelDetails style={{ display: 'block' }}>
                        //         <DataTable
                        //             rows={taskschedules.filter(i => i.typeEventId === 3).map(i => ({
                        //                 id: i.id,
                        //                 dtRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy')),
                        //                 timeRegister: (moment(i.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm')),
                        //                 type: i.timeclock.type == 'I' ? 'Entrada' : 'Saída',
                        //                 name: i.employee.name,
                        //                 addressLocation: i.timeclock.addressLocation,
                        //             }))}
                        //             columns={columns}
                        //             outRowsPerPage={5}
                        //             actions={actions}
                        //             loading={loading}
                        //         />
                        //         <div style={{
                        //             display: 'flex', justifyContent: 'flex-end',
                        //         }}>
                        //             {!isPremium == true ? (<DialogActions>
                        //                 <DialogContentText style={{ fontSize: '14px', color: '#2880ca', right: '20px', bottom: '-15px', position: 'relative' }}>
                        //                     *Assine o Plano Premium para acessar as ações.
                        //                 </DialogContentText>
                        //                 <Button variant="contained" color="primary" component={Link} style={{ left: '-21px', bottom: ' -8px' }} to='/assinatura'>
                        //                     <Star /> RESOLVA AQUI! SEJA PREMIUM <Star />
                        //                 </Button>
                        //             </DialogActions>) : ''}
                        //             <Button disabled={!isPremium} variant="outlined" onClick={this.handleModalAproveAll} color="primary" style={{ left: '-21px', bottom: ' -8px' }}>
                        //                 Aprovar Pontos Duplicados
                        //             </Button>
                        //             <Dialog
                        //                 open={this.state.openModalAproveAll}
                        //                 onClose={status => this.closeModal("modalAproveAll")}
                        //                 aria-labelledby="title"
                        //                 aria-describedby="description"
                        //             >
                        //                 <DialogTitle id="title">
                        //                     Aprovar TODOS os pontos duplicados.
                        //                 </DialogTitle>
                        //                 <DialogContent>
                        //                     <DialogContentText id="description">
                        //                         Confirme a aprovação digitando <b>APROVADO</b> no campo abaixo.
                        //                     </DialogContentText>
                        //                 </DialogContent>
                        //                 <TextField
                        //                     style={{ margin: '0px 24px 13px 24px' }}
                        //                     autoFocus
                        //                     margin="dense"
                        //                     name="name"
                        //                     label="Digite aqui"
                        //                     type="text"
                        //                     onChange={event => this.handleChange(event, 'descricaoAproveAll')}
                        //                     value={this.state.descricaoAproveAll}
                        //                     required
                        //                 />
                        //                 <DialogActions>
                        //                     <Button onClick={status => this.closeModal("modalAproveAll")}> CANCELAR </Button>
                        //                     {this.state.descricaoAproveAll.trim() === "APROVADO" ?
                        //                         (<Button
                        //                             onClick={this.approveAll}
                        //                             variant="contained"
                        //                             color="primary">
                        //                             CONFIRMAR
                        //                         </Button>) :
                        //                         <Button
                        //                             disabled
                        //                             onClick={this.approveAll}
                        //                             variant="contained"
                        //                             color="primary">
                        //                             CONFIRMAR
                        //                         </Button>}
                        //                 </DialogActions>
                        //             </Dialog>
                        //         </div>
                        //     </ExpansionPanelDetails>
                        // </ExpansionPanel>
                        <></>
                } */}
                <Dialog
                    open={this.state.openModalTipo}
                    onClose={modal => this.closeModal('openModalTipo')}
                    aria-labelledby="title"
                    aria-describedby="description"
                >
                    <DialogTitle id="title">
                        Ponto Duplicado
                    </DialogTitle>
                    <DialogContent id="description">
                        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '-15px' }}>
                            <List>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <Person color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Nome:" secondary={this.state.currentStatus.employee.name} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <DateRange color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Data:" secondary={(moment(this.state.currentStatus.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <Schedule color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Hora:" secondary={(moment(this.state.currentStatus.timeclock.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm'))} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <TransferWithinAStation color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Tipo:" secondary={this.state.currentStatus.timeclock.type === "I" ? 'Entrada' : 'Saída'} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <Description color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Endereço:" secondary={this.state.currentStatus.timeclock.addressLocation} />
                                </ListItem>
                                <Divider />
                                <div> Registro Anterior</div>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <DateRange color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Data:" secondary={(moment(this.state.currentStatus.rulerdetailsjson.previousTimeclockData.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <Schedule color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Hora:" secondary={(moment(this.state.currentStatus.rulerdetailsjson.previousTimeclockData.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('HH:mm'))} />
                                </ListItem>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar style={{ backgroundColor: '#eaeaea' }}>
                                            <TransferWithinAStation color='primary' />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary="Tipo:" secondary={this.state.currentStatus.rulerdetailsjson.previousTimeclockData.type === "I" ? 'Entrada' : 'Saída'} />
                                </ListItem>
                            </List>
                            <div className={classNames(classes.timeInputContainer, 'display-flex')}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="age-simple">Tipo</InputLabel>
                                    <Select
                                        required
                                        value={this.state.type}
                                        onChange={event => this.handleChange(event, 'type')}
                                        inputProps={{
                                            name: 'type',
                                            id: 'ponto-type',
                                        }}
                                    >
                                        <MenuItem value="I">Entrada</MenuItem>
                                        <MenuItem value="O">Saída</MenuItem>
                                    </Select>
                                </FormControl>

                                <TextField
                                    required
                                    label="Justificativa"
                                    value={this.state.observationDescription}
                                    onChange={event => this.handleChange(event, 'observation')}
                                    className={classNames(classes.textField, classes.dense)}
                                    margin="dense"
                                />
                            </div>
                            <div>
                                <DialogActions>
                                    {!isPremium ? (<Button variant="contained" color="primary" component={Link} to='/assinatura'>
                                        <Star />  RESOLVA AQUI! SEJA PREMIUM <Star />
                                    </Button>) : ''}
                                    <Button onClick={modal => this.closeModal('openModalTipo')}>CANCELAR</Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        onClick={status => this.updateType('REJEITADO')}
                                        disabled={!this.state.type || !this.state.observationDescription || !isPremium}
                                    >
                                        CONFIRMAR
                                    </Button>
                                </DialogActions>
                            </div>
                        </div >
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={this.state.openAdd}
                    onClose={modal => this.closeModal('openAdd')}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">Adicionar Ponto</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Informe o horário para o novo ponto.
                        </DialogContentText>
                        <div className={classNames(classes.timeInputContainer, 'display-flex')}>
                            Novo horário e data:
                            <span className={classNames(classes.basis50, classes.timeSpan)}>
                                <Input
                                    className={classes.dateTimeInput}
                                    elementType='datePicker'
                                    label="Data"
                                    margin="normal"
                                    value={this.state.newDate}
                                    onChange={event => this.handleChange(event, 'date')}
                                    required
                                />
                                <Input
                                    className={classes.dateTimeInput}
                                    style={{ marginLeft: '22px' }}
                                    elementType='timePicker'
                                    label="Horario"
                                    margin="normal"
                                    value={this.state.newTime}
                                    onChange={event => this.handleChange(event, 'time')}
                                    required
                                />
                            </span>

                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="age-simple">Tipo</InputLabel>
                                <Select
                                    required
                                    value={this.state.type}
                                    onChange={event => this.handleChange(event, 'type')}
                                    inputProps={{
                                        name: 'type',
                                        id: 'ponto-type',
                                    }}
                                >
                                    <MenuItem value="I">Entrada</MenuItem>
                                    <MenuItem value="O">Saída</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                required
                                label="Justificativa"
                                value={this.state.observationDescription}
                                onChange={event => this.handleChange(event, 'observation')}
                                className={classNames(classes.textField, classes.dense)}
                                margin="dense"
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        {!isPremium ? (<Button variant="contained" color="primary" component={Link} to='/assinatura'>
                            <Star />  RESOLVA AQUI! SEJA PREMIUM <Star />
                        </Button>) : ''}
                        <Button onClick={modal => this.closeModal('openAdd')}>CANCELAR</Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={!this.state.observationDescription.length || !this.state.newTime || !this.state.newDate || !this.state.type || !isPremium}
                            onClick={status => this.finishActions('REJEITADO')}
                        >
                            CONFIRMAR
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openModalAprovar}
                    onClose={modal => this.closeModal('openModalAprovar')}>
                    <DialogTitle>Você esta aprovando esse Ponto.</DialogTitle>
                    <DialogContent>
                        <div>
                            <DialogContentText>Deixe uma justificativa.</DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                name="name"
                                label="justificativa"
                                type="text"
                                onChange={event => this.handleChange(event, 'observation')}
                                value={this.state.observationDescription}
                                required
                                fullWidth
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        {!isPremium ? (<Button variant="contained" color="primary" component={Link} to='/assinatura'>
                            <Star />  RESOLVA AQUI! SEJA PREMIUM <Star />
                        </Button>) : ''}
                        <Button onClick={modal => this.closeModal('openModalAprovar')}>CANCELAR</Button>
                        <Button
                            disabled={!this.state.observationDescription || !isPremium}
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={status => this.handleAprova('APROVAR')} autoFocus>
                            CONFIRMAR
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openReprove}
                    onClose={modal => this.closeModal('openReprove')}>
                    <DialogTitle>Você esta inativando esse Ponto.</DialogTitle>
                    <DialogContent>
                        <div>
                            <DialogContentText>Deixe uma justificativa.</DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                name="name"
                                label="justificativa"
                                type="text"
                                onChange={event => this.handleChange(event, 'observation')}
                                value={this.state.observationDescription}
                                required
                                fullWidth
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        {!isPremium ? (<Button variant="contained" color="primary" component={Link} to='/assinatura'>
                            <Star />  RESOLVA AQUI! SEJA PREMIUM <Star />
                        </Button>) : ''}
                        <Button onClick={modal => this.closeModal('openReprove')}>CANCELAR</Button>
                        <Button
                            disabled={!this.state.observationDescription || !isPremium}
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={status => this.rejectPoint('REJEITADO')} autoFocus>
                            CONFIRMAR
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.general.loading,
    taskschedules: state.taskSchedule.tasks
});

const mapDispatchToProps = dispatch => ({
    onFetchTaskSchedules: () => dispatch(fetchTaskSchedules()),
    onUpdateTaskScheduleName: (id, name, description) => dispatch(updateTaskScheduleName(id, name, description)),
});

export const StyledComponent = withStyles(styles)(TaskScheduleDuplicatePoint);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(StyledComponent));
